import styled from 'styled-components'

const WrapComponent = styled.div`
    --height-header: 85px;
    display: flex;
    height: calc(100% - var(--height-header));
    min-height: calc(100vh - var(--height-header));
    .bank-page-tpbank{
        display: grid;
        width: 100%;
        grid-template-columns: 1fr;
        position: relative;
        .overlay{
            background: linear-gradient(180deg, #7B4FA4 0%, #512879 100%);
            width: 100%;
            height: 65%;
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
        }
        .block-left{
            display: none;
            width: 338px;
            height: 100%;
            background: linear-gradient(180deg, #7B4FA4 0%, #512879 100%);
            position: relative;
        }
        .block-right{
            display: flex;
            width: 100%;
            z-index: 1;
        }        
    }
    @media only screen and (min-width: 768px){
        .bank-page-tpbank{
            grid-template-columns: auto 1fr;
            .overlay{
                display: none;
            }
            .block-left{
                display: block;
                .icon{
                    position: absolute;
                    top: 66px;
                    left: 38px;
                }
            }
            .block-right{
                background: #FFFFFF;
                height: 100%;
            }        
        }
    }
    @media only screen and (min-width: 1024px){
        .bank-page-tpbank{
            .block-left{
                display: flex;
            }
        }
    }
`

export { WrapComponent }